(function organizationalUnitDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminOrganizationalUnitService', [
            'restUrlBuilder', '$injector', function organizationalUnitService(restUrlBuilder, $injector) {

                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function (id) {
                    return restUrlBuilder.one('adminOrganizationalUnits', id).get();
                };

                this.getImagesById = function (id) {
                    return restUrlBuilder.one('adminOrganizationalUnits/getImages', id).put();
                };

                this.getTreeOf = function (id) {
                    var params = { TreeOf: id };
                    return restUrlBuilder.all('adminOrganizationalUnits')
                        .get({ params: params });
                };

                this.getConfigs = function (id) {
                    return restUrlBuilder.one('adminOrganizationalUnits/Configs', id).get();
                };

                this.get = function (name, notInTreeId, allOu, page, itemsPerPage) {

                    var params = {
                        Name: name
                        , NotInTree: notInTreeId
                        , All: allOu
                        , Page: page
                        , ItemPerPage: itemsPerPage
                    };

                    return restUrlBuilder.all('adminOrganizationalUnits')
                        .get({ params: params });
                };

                this.create = function (organizationalUnit, files, icon, startImage) {
                    if (organizationalUnit == null)
                        throw 'documentType no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.all('adminOrganizationalUnits/Images').url,
                        method: 'POST',
                        fields: { icon: icon, startImage: startImage, ou: JSON.stringify(organizationalUnit) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };

                this.modify = function (organizationalUnit, files, icon, startImage) {
                    if (organizationalUnit == null)
                        throw 'documentType no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.one('adminOrganizationalUnits/', organizationalUnit.id).url,
                        method: 'PUT',
                        fields: { icon: icon, startImage: startImage, ou: JSON.stringify(organizationalUnit) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });

                };

                this.enable = function enable(ou) {
                    if (ou == null) {
                        throw "ou no puede ser null";
                    }

                    return restUrlBuilder.one('adminOrganizationalUnits/enable', ou.id).put();
                };

                this.disable = function disable(ou) {
                    if (ou == null) {
                        throw "ou no puede ser null";
                    }

                    return restUrlBuilder.one('adminOrganizationalUnits/disable', ou.id).put();
                };

            }
        ]);
})();